"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _core = require("@material-ui/core");

var _organisations = require("../../utils/organisations");

var _jsxRuntime = require("react/jsx-runtime");

function OperaStatus(props) {
  if (!props.organisation || !props.organisation.interoperatedOrganisation || !props.organisation.interoperatedOrganisation.enabled || props.masterPlatformToShow && props.masterPlatformToShow !== props.organisation.interoperatedOrganisation.masterPlatform) {
    return null;
  }

  var masterPlatform = props.organisation.interoperatedOrganisation.masterPlatform;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-id": "render-opera-status",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tooltip, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "opera.platform-".concat(masterPlatform, ".message")
      }),
      placement: "bottom",
      children: props.small ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: "/resources/img/icon_opera_small.png",
        alt: "opera"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: "/resources/img/icon_opera.png",
        alt: "opera"
      })
    })
  });
}

OperaStatus.defaultProps = {
  small: false
};
OperaStatus.propTypes = {
  organisation: (0, _organisations.organisationPropTypes)(),
  small: _propTypes.default.bool,
  masterPlatformToShow: _propTypes.default.string
};
var _default = OperaStatus;
exports.default = _default;
//# sourceMappingURL=OperaStatus.js.map